import { isNotEmptyString, isNotNullOrUndefined } from '@vy/utils';
import type { FilterLine } from './types';
import { isArray, isString } from 'lodash';

function isValidFilter(filter: FilterLine): boolean {
  if (isArray(filter.value)) {
    const isNotEmpty = filter.value.length > 0;

    return isNotEmpty && hasValidArrayValue(filter.value);
  }

  if (typeof filter.value === 'string') {
    return isNotEmptyString(filter.value);
  }

  return isNotNullOrUndefined(filter.value) && !isNaN(Number(filter.value));
}

export function hasValidArrayValue(value: string[] | number[]): boolean {
  return value.some((item) => {
    if (isString(item)) {
      return isNotEmptyString(item);
    }

    return isNotNullOrUndefined(item) && !isNaN(Number(item));
  });
}

export function getValidFilters(filters: FilterLine[] | null | undefined): FilterLine[] {
  return (filters ?? []).filter(isValidFilter);
}

export function hasIncompleteFilter(filter: FilterLine): boolean {
  return !filter.field || !filter.operator || !isValidFilter(filter);
}

export function hasSelectedField(filter: FilterLine): boolean {
  return isNotEmptyString(filter.field);
}

export function hasSelectedOperator(filter: FilterLine): boolean {
  return !!filter.operator;
}
